import streamingProtocolTypes from '../Constants/streamingProtocolTypes';

const inferStreamingProtocol = userDevice => {
    let streamingProtocol = streamingProtocolTypes.DASH;

    if (userDevice.isSafari) {
        streamingProtocol = streamingProtocolTypes.HLS;
    }

    if (userDevice.isEdge || userDevice.isInternetExplorer) {
        streamingProtocol = streamingProtocolTypes.SMOOTH_STREAMING;
    }

    return streamingProtocol;
};

export default inferStreamingProtocol;
